// Utility functions for exporting data to CSV and Excel formats

/**
 * Convert array of objects to CSV string
 */
export const convertToCSV = (data, columns = null) => {
  if (!data || data.length === 0) return '';

  // Use provided columns or extract from first object
  const headers = columns || Object.keys(data[0]);
  
  // Create CSV header row
  const headerRow = headers.join(',');
  
  // Create data rows
  const dataRows = data.map(item => {
    return headers.map(header => {
      const value = item[header] || '';
      // Escape quotes and wrap in quotes if contains comma
      const escapedValue = String(value).replace(/"/g, '""');
      return escapedValue.includes(',') ? `"${escapedValue}"` : escapedValue;
    }).join(',');
  });
  
  return [headerRow, ...dataRows].join('\n');
};

/**
 * Download CSV file
 */
export const downloadCSV = (csvContent, filename = 'export.csv') => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

/**
 * Export testimonials to CSV
 */
export const exportTestimonialsToCSV = (testimonials) => {
  const columns = ['name', 'event_type', 'date', 'rating', 'comment', 'approved'];
  
  const formattedData = testimonials.map(t => ({
    name: t.name,
    event_type: t.event_type,
    date: t.date || new Date().toISOString().split('T')[0],
    rating: t.rating || 5,
    comment: t.comment,
    approved: t.approved ? 'Oui' : 'Non',
  }));
  
  const csv = convertToCSV(formattedData, columns);
  const filename = `temoignages_${new Date().toISOString().split('T')[0]}.csv`;
  downloadCSV(csv, filename);
};

/**
 * Export gallery items to CSV
 */
export const exportGalleryToCSV = (galleryItems) => {
  const columns = ['title', 'type', 'url', 'order'];
  
  const formattedData = galleryItems.map(item => ({
    title: item.title || 'Sans titre',
    type: item.type,
    url: item.url,
    order: item.order || 0,
  }));
  
  const csv = convertToCSV(formattedData, columns);
  const filename = `galerie_${new Date().toISOString().split('T')[0]}.csv`;
  downloadCSV(csv, filename);
};

/**
 * Export stats to CSV
 */
export const exportStatsToCSV = (stats) => {
  const columns = ['label', 'value'];
  
  const formattedData = stats.map(stat => ({
    label: stat.label,
    value: stat.value || stat.number,
  }));
  
  const csv = convertToCSV(formattedData, columns);
  const filename = `statistiques_${new Date().toISOString().split('T')[0]}.csv`;
  downloadCSV(csv, filename);
};
